import {useCallback} from 'react';
import {Concept} from 'types';
import type {VerifiedLinkedValueLink} from 'schemaDefinition/types';
import type {Agent, AgentWorkSummary} from 'services/agent/types';
import {useLocalization} from 'localization';
import {Builder} from 'services/utils';
import type {SearchResultType} from '../types';
import {useEntitySearchContext} from '../context';
import {getEntityTitle} from '../context/functions/getEntityTitle';

type AgentWorkLink =
  | ((row: Pick<AgentWorkSummary, 'id' | 'preferredTitle'>) => void)
  | undefined;

export const useAgentWorkLink = (
  agentValue: Agent | undefined,
  type: SearchResultType,
): AgentWorkLink => {
  const {t} = useLocalization();
  const {navigateTo} = useEntitySearchContext();

  const onNavigate = useCallback(
    (link: VerifiedLinkedValueLink) => {
      const backTitle = getEntityTitle(agentValue, type, agentValue?.id);
      const backType = t(`general.entity.${type}`);
      const backLabel =
        new Builder(backType).add(': ', backTitle).value ?? t('general.back');
      navigateTo(link, backLabel);
    },
    [agentValue, navigateTo, t, type],
  );

  return useCallback(
    ({id, preferredTitle}: Pick<AgentWorkSummary, 'id' | 'preferredTitle'>) => {
      onNavigate({
        linkStatus: 'verified',
        entityId: id,
        type: Concept.work,
        name: (preferredTitle ?? [])?.join(', '),
      });
    },
    [onNavigate],
  );
};
